<template>
  <div class="api__cta">BUY NOW</div>
  <div class="api__bg">
    <div id="t" class="api">
      <div
        v-for="item in dataModel[props.brandExperience].retailers"
        :key="item.retailer"
        class="api__retailer"
      >
        <a
          :href="item.url"
          class="api__a"
          data-action="csClickToRetailer"
          target="_blank"
        >
          <div
            class="api__img-wrapper temp__center"
            data-action="csClickToRetailer"
          >
            <img
              :src="item.logo"
              class="api__img--logo"
              data-action="csClickToRetailer"
            />
          </div>
          <div class="api__price" data-action="csClickToRetailer">
            £{{ item.price }}
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    resizeOverflow() {
      var element = document.querySelector("#t");
      if (element.offsetWidth < element.scrollWidth) {
        // your element have overflow
        $(".api").css({
          "justify-content": "flex-start",
        });
      } else {
        //your element don't have overflow
        $(".api").css({
          "justify-content": "center",
        });
      }
    },
  },
  mounted() {
    this.resizeOverflow();
  }
};
</script>
<script setup>
import gsap from "gsap";
import dataModel from "../js/model.js";

const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  },
});
$(document).ready(function () {
  $(".hero__button").on("click", function () {
    gsap.to(".api__retailer", {
      duration: 0.25,
      stagger: 0.1,
      opacity: 0,
      onComplete: () => {
        $(".api").html("");
        Object.keys(dataModel[targObj].retailers).forEach(function (k, i) {
          $(".api").append(`
            <div class="api__retailer" style="opacity: 0;">
              <a href="${
                dataModel[targObj].retailers[i + 1].url
              }" class="api__a" target="_blank" data-action="csClickToRetailer">
                  <div class="api__img-wrapper temp__center" data-action="csClickToRetailer">
                    <img src="${
                      dataModel[targObj].retailers[i + 1].logo
                    }" class="api__img--logo" data-action="csClickToRetailer" />
                  </div>
                  <div class="api__price" data-action="csClickToRetailer">£${
                    dataModel[targObj].retailers[i + 1].price
                  }</div>
                </a>
              </div>
            `);
        });
        gsap.to(".api__retailer", {
          duration: 0.25,
          stagger: 0.1,
          opacity: 1,
        });
      },
    });
    var dId = $(this).attr("data-id");
    var targObj;
    dId === "1" ? (targObj = 2) : (targObj = 1);
  });

  var tlWidget = gsap.timeline({ repeat: -1 });

  tlWidget
    .to(".api__price", {
      backgroundColor: "#BCA35F",
      duration: 0.5,
      stagger: 0.1,
      delay: 5,
    })
    .to(".api__price", {
      backgroundColor: "#A51329",
      duration: 0.5,
      stagger: 0.1,
    });

  if (window.innerWidth < 476) {
    $(".api__cta").css({
      bottom: function () {
        return $(".api__bg").innerHeight();
      },
    });
  } else {
    $(".api__cta").css({
      bottom: "0px",
    });
  }
  $(window).resize(function () {
    if (window.innerWidth < 476) {
      $(".api__cta").css({
        bottom: function () {
          return $(".api__bg").innerHeight();
        },
      });
    } else {
      $(".api__cta").css({
        bottom: "0px",
      });
    }
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.api__cta {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  background-color: $color--gold;
  border-radius: 10px 10px 0px 0px;
  color: #ffffff;
  height: 50px;
  font-size: 20px;
  margin: auto;
  position: relative;
  width: 100px;
  &::after {
    border-top: 6px solid $color--gold;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    content: "";
    position: absolute;
    bottom: -6px;
  }
  @media screen and (max-width: 475px) {
    left: calc(50% - 50px);
    position: fixed;
    z-index: 1000;
  }
}
.api__bg {
  background: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  display: inline-block;
  max-width: 670px;
  min-width: none;
  overflow: scroll;
  z-index: 10000;
  @media screen and (max-width: 475px) {
    border-top: 2px solid $color--gold;
    border-radius: 0px;
    bottom: 0px;
    left: 0px;
    margin-right: 10px;
    overflow: scroll;
    position: fixed;
    width: 100%;
    z-index: 150;
  }
}
.api {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  padding: 10px;
  width: 100%;

  @media screen and (max-width: 475px) {
    @include justify-content(flex-start);
  }
}
.api__retailer {
  border: 1px solid #f0f0f0;
  border-radius: 5px;
  max-width: 100px;
  min-width: 70px;
  position: relative;
  &:not(:last-child) {
    margin-right: 10px;
  }
  &:last-child:after {
    content: "";
    position: absolute;
    height: 100%;
    right: -10px;
    top: 0;
    background: none;
    width: 20px;
  }
}
.api__img-wrapper {
  padding: 5px;
  @media screen and (max-width: 475px) {
    max-height: 47px;
    width: auto;
  }
}
.api__img--logo {
  display: block;
  width: 90%;
  @media screen and (max-width: 475px) {
    max-height: 37px;
    width: auto;
  }
}
.api__a {
  color: #333333;
  text-decoration: none;
}
.api__price {
  background-color: $color--red;
  border-radius: 0px 0px 5px 5px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 0px;
  text-align: center;
}
::-webkit-scrollbar {
    display: none;
}
</style>